import React from 'react';
import {
  Flex, Container, Heading, Text, Button, Box, Image,
} from '@chakra-ui/react';
import Logo from '@components/Logo';
import ErrorBoundaryImage from '@assets/error_boundary.svg'

const Content = () => {
  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <Container maxW="5xl" py={10}>
      <Flex direction="column" align="center" gap={3}>
        <Logo width={100} />

        <Image
          src={ErrorBoundaryImage}
          alt="Erro na aplicação"
          width={{ base: '100%', md: 400 }}
        />

        <Box textAlign="center" mt={4}>
          <Heading>
            Oops... Parece que algo deu errado!
          </Heading>
          <Text>
            Não se preocupe, estamos trabalhando para resolver o problema.
          </Text>
        </Box>
        
        <Button mt={4} colorPalette="argos" onClick={handleGoHome}>
          Voltar para a página inicial
        </Button>
      </Flex>
    </Container>
  );
};

class ErrorBoundary extends React.Component<{ children?: React.ReactNode }, { hasError: boolean }> {
  constructor(props: { children?: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { hasError } = this.state;

    if (hasError) {
      return <Content />;
    }

    return this.props.children;
  }
};

export default ErrorBoundary;
